var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79411 5.364C6.06811 7.497 7.18311 10.321 8.06011 12.453C8.47611 13.465 9.13311 14.478 9.68911 15.293C10.6621 16.717 12.8781 19.423 15.5901 19.015C16.7581 18.839 18.1171 17.46 17.1871 16.579L15.3181 14.639C15.3181 14.639 14.7951 14.203 14.1471 14.559L13.0991 15.172C13.0991 15.172 12.6711 15.374 12.3001 14.897C11.1371 13.526 10.3051 12.1 9.72211 10.401C9.49511 9.738 9.89011 9.573 9.89011 9.573L10.6571 9.123C11.2941 8.745 11.1811 8.072 11.1811 8.072L10.7431 5.334C10.6111 4.766 10.1421 4.531 9.59811 4.531C8.95011 4.531 8.19811 4.865 7.79411 5.364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialOutIcon);
export default __webpack_public_path__ + "static/media/_DialOutIcon_.87c072f321cb9d6f9b1fbd07d5684b4f.svg";
export { ForwardRef as ReactComponent };